module.exports = __webpack_public_path__ + "static/media/acp-logo-2019.color.a85c49f8.png";